<p class="modal-title flex items-center gap-8">
  <svg-icon
    src="assets/icons/games/case-openings.svg"
    class="modal-title__icon flex items-center justify-center s-16"
  />
  Case Creator Items
</p>
<div class="flex w-full filters items-center">
  <app-search-input
    [disabled]="
      adminAllSkinsResource.isLoading() || !!adminAllSkinsResource.error()
    "
    [(query)]="search"
  />
  <app-input-options
    label="From:"
    [(value)]="fromPrice"
    placeholder="Price..."
    [settings]="{
optionType: 'square',
maskSettings: {
  mask: 'separator.2',
},}"
  />

  <app-input-options
    label="To:"
    [(value)]="toPrice"
    placeholder="Price..."
    [settings]="{
optionType: 'square',
maskSettings: {
  mask: 'separator.2',
},}"
  />

  <app-select
    [title]="'Sort by'"
    [selected]="sort()"
    [options]="sortOptions"
    [disabled]="
      adminAllSkinsResource.isLoading() || !!adminAllSkinsResource.error()
    "
  />
</div>
<div class="divider horizontal w-full divider-between-header-and-content"></div>
@if (adminAllSkinsResource.error()) {
<div
  style="text-align: center"
  class="flex flex-col gap-4 items-center justify-center w-full h-full skins"
>
  {{ adminAllSkinsResource.error() }}
  <button
    class="button button--style-primary h-32 padding-x-12 rounded-4"
    (click)="adminAllSkinsResource.reload()"
  >
    Reload
  </button>
</div>
} @else if (adminAllSkinsResource.isLoading()) {
<div class="skins skins--skeleton">
  @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14, 15, 16, 17, 18, 19,
  20]; track $index) {
  <div
    class="h-full w-full skeleton-animation rounded-4"
    style="background: var(--gray-24); height: 100%"
  ></div>
  }
</div>
} @else {
<app-skins-list
  class="skins"
  [skins]="skins()"
  [(selectedSkins)]="adminCaseEditService.caseSkins"
  [selectable]="true"
  [config]="{ mobile: { skin_min_width: '150px' } }"
/>
}
<div class="summary">
  <div class="summary--container">
    <div class="summary--content">
      <svg-icon
        class="bg"
        src="assets/images/ui-effects/background-vector.svg"
      />
      <div class="summary--selected-items">
        <app-cost [cost]="selectedSkinsPrice()" />
        <span class="summary--selected-items__text typography-info"
          >{{ adminCaseEditService.caseSkins().length }} items selected</span
        >
      </div>
      <div class="divider vertical h-full"></div>
      <button
        (click)="refreshInventory()"
        class="button button--style-primary padding-x-12 refresh-store--button"
        style="--button-height: 32px"
        [disabled]="adminAllSkinsResource.isLoading()"
      >
        <svg-icon
          class="panel-icon flex items-center justify-center s-14"
          src="assets/icons/ui/refresh.svg"
          [class.icon-rotating]="isShowRefreshAnimation()"
        ></svg-icon>
        Refresh store
      </button>

      <!--  -->
      <button
        class="summary--action-button button button--style-yellow padding-x-12"
        style="--button-height: 38px"
        (click)="closeModal()"
      >
        Close
      </button>
    </div>
  </div>
</div>
